import { api, modal } from './util';

/**
 * Plugin for modal dialog which creates a new medical device group.
 */
(function ($) {
	var form;

	var createApiRequest = function () {
		var url = '/users/' + encodeURIComponent(api.getUserId()) + '/medical-device-groups';
		var operatorFromUrl = /operator=([^&]+)/.exec(window.location);
		var data = {
			operator: operatorFromUrl ? operatorFromUrl[1] : 'and',
			name: form.find('[name=name]').val().trim(),
		};

		return api.post(url, data).done(function (response) {
			$(document).trigger('medicalDeviceGroup.created', response);
		});
	};

	$.fn.createMedicalDeviceGroupModal = function (modalSelector) {
		this.click(function () {
			modal.show(modalSelector);
			form = $('.modal ' + modalSelector);
			form.validateForm();
			form.find('[type=submit]').apiButton(createApiRequest);

			return false;
		});

		return this;
	};
})(jQuery);

/**
 * Plugin for modal dialog which updates medical device group notification settings.
 */
(function ($) {
	var groupId;
	var form;

	var createApiRequest = function () {
		var url =
			'/users/' +
			encodeURIComponent(api.getUserId()) +
			'/medical-device-groups/' +
			encodeURIComponent(groupId) +
			'/notification-settings';
		var data = {
			zpscauDiffFrequency: form.find('[name=zpscau-diff-enabled]').is(':checked')
				? form.find('[name=zpscau-diff-frequency]').val()
				: 'disabled',
			zumSzpDiffFrequency: form.find('[name=zum-szp-diff-enabled]').is(':checked')
				? form.find('[name=zum-szp-diff-frequency]').val()
				: 'disabled',
			zumVzpDiffFrequency: form.find('[name=zum-vzp-diff-enabled]').is(':checked')
				? form.find('[name=zum-vzp-diff-frequency]').val()
				: 'disabled',
			procedureFrequency: form.find('[name=procedure-enabled]').is(':checked')
				? form.find('[name=procedure-frequency]').val()
				: 'disabled',
			distributionFrequency: form.find('[name=distribution-enabled]').is(':checked')
				? form.find('[name=distribution-frequency]').val()
				: 'disabled',
		};

		return api.put(url, data).done(function (response) {
			$(document).trigger('medicalDeviceGroup.notificationSettingsSaved', [groupId, response]);
		});
	};

	var validateForm = function () {
		form.find('[type=submit]').prop('disabled', disableForm(form));
	};

	var disableForm = function () {
		return false;
	};

	$.fn.medicalDeviceNotificationSettingsModal = function (modalSelector) {
		this.click(function () {
			modal.show(modalSelector);

			var medicalDeviceGroupContainer = $(this).closest('.medical-device-group');
			var zpscauDiffFrequency = medicalDeviceGroupContainer.data('zpscau-diff-frequency');
			var zumSzpDiffFrequency = medicalDeviceGroupContainer.data('zum-szp-diff-frequency');
			var zumVzpDiffFrequency = medicalDeviceGroupContainer.data('zum-vzp-diff-frequency');
			var procedureFrequency = medicalDeviceGroupContainer.data('procedure-frequency');
			var distributionFrequency = medicalDeviceGroupContainer.data('distribution-frequency');

			// Initialize the notification settings form.
			groupId = medicalDeviceGroupContainer.data('group-id');
			form = $('.modal ' + modalSelector);

			if (zpscauDiffFrequency === 'disabled') {
				form.find('[name=zpscau-diff-enabled]').prop('checked', false);
			} else {
				form.find('[name=zpscau-diff-enabled]').prop('checked', true);
				form.find('[name=zpscau-diff-frequency]').val(zpscauDiffFrequency);
			}

			if (zumSzpDiffFrequency === 'disabled') {
				form.find('[name=zum-szp-diff-enabled]').prop('checked', false);
			} else {
				form.find('[name=zum-szp-diff-enabled]').prop('checked', true);
				form.find('[name=zum-szp-diff-frequency]').val(zumSzpDiffFrequency);
			}

			if (zumVzpDiffFrequency === 'disabled') {
				form.find('[name=zum-vzp-diff-enabled]').prop('checked', false);
			} else {
				form.find('[name=zum-vzp-diff-enabled]').prop('checked', true);
				form.find('[name=zum-vzp-diff-frequency]').val(zumVzpDiffFrequency);
			}

			if (procedureFrequency === 'disabled') {
				form.find('[name=procedure-enabled]').prop('checked', false);
			} else {
				form.find('[name=procedure-enabled]').prop('checked', true);
				form.find('[name=procedure-frequency]').val(procedureFrequency);
			}

			if (distributionFrequency === 'disabled') {
				form.find('[name=distribution-enabled]').prop('checked', false);
			} else {
				form.find('[name=distribution-enabled]').prop('checked', true);
				form.find('[name=distribution-frequency]').val(distributionFrequency);
			}

			form.find('[type=submit]').apiButton(createApiRequest);

			// Validate the form.
			validateForm();
		});

		return this;
	};
})(jQuery);

/**
 * Plugin for modal dialog which renames a medical device group.
 */
(function ($) {
	var groupId;
	var form;

	var createApiRequest = function () {
		var url = '/users/' + encodeURIComponent(api.getUserId()) + '/medical-device-groups/' + encodeURIComponent(groupId);
		var data = {
			name: form.find('[name=name]').val().trim(),
		};

		return api.put(url, data).done(function (response) {
			$(document).trigger('medicalDeviceGroup.renamed', response);
		});
	};

	$.fn.renameMedicalDeviceGroupModal = function (modalSelector) {
		this.click(function () {
			modal.show(modalSelector);

			var medicalDeviceGroupContainer = $(this).closest('.medical-device-group');
			var groupName = medicalDeviceGroupContainer.find('.medical-device-group-name:first').text();

			groupId = medicalDeviceGroupContainer.data('group-id');
			form = $('.modal ' + modalSelector);
			form.find('[name=name]').val(groupName);
			form.validateForm();
			form.find('[type=submit]').apiButton(createApiRequest);
		});

		return this;
	};
})(jQuery);

/**
 * Plugin for modal dialog which removes a medical device group.
 */
(function ($) {
	var groupId;

	var createApiRequest = function () {
		return api
			.delete('/users/' + encodeURIComponent(api.getUserId()) + '/medical-device-groups/' + encodeURIComponent(groupId))
			.done(function () {
				$(document).trigger('medicalDeviceGroup.removed', groupId);
			});
	};

	$.fn.removeMedicalDeviceGroupModal = function (modalSelector) {
		this.click(function () {
			modal.show(modalSelector);
			groupId = $(this).closest('.medical-device-group').data('group-id');
			$('.modal ' + modalSelector + ' [type=submit]').apiButton(createApiRequest);
		});

		return this;
	};
})(jQuery);
